import WOW from '../../js/pages/client-admin-app/wow.min'
import $ from "jquery";

//console.log('initWordpressPage.js');

let $offset = 120;



// if($('.faq-section .masonry-grid--item-toggler')){
//     $('.faq-section .masonry-grid--item-toggler').on('click', function (){
//         $(this).toggleClass('--active');
//         $(this).closest('.masonry-grid--item').find('.masonry-grid--item-body').slideToggle();
//     })
// }

if ( $(window).width() < 768) {
    $offset = 70;
} else {
    $offset = 120;
}

new WOW({
    offset: $offset
}).init();



